// would be great if we could just generate this somehow

export enum EditorNames {
  Array = 'default:array',
  CalendarEditor = 'CalendarEditor',
  CheckBox = 'default:check',
  NullableCheckBox = 'default:nullablecheck',
  Combo = 'default:combo',
  EditableDropDown = 'EditableDropDownEditor',
  Readonly = 'default:readonly',
  DisplayString = 'DisplayStringEditor',
  Digits = 'default:digits',
  String = 'default:string',
  StringEditor = 'StringEditor',
  TextArea = 'LongTextEditor',
  RichText = 'RichTextInputEditor',
  GridPopup = 'default:gridPopup',
  SelectElementRegistrationEditor = 'SelectElementRegistrationEditor',
  EntityPicker = 'EntityPickerEditor',
  CheckList = 'CheckListEditor',
  Mappings = 'MappingTypeSelector',
  StringArray = 'StringArrayEditor',
  NumericArray = 'NumericArrayEditor',
  NumberFormat = 'NumberFormatEditor',
  Assignees = 'AssigneesEditor',
  ReportMergeTextEditor = 'ReportMergeTextEditor',
  RowLinkTextEditor = 'RowLinkTextEditor',
  SuggestStringEditor = 'SuggestStringEditor',
  DataDefinitionsEditor = 'DataDefinitionsEditor',
  MergeTextEditor = 'MergeTextEditor',
  TextMergeFieldSelector = 'TextMergeFieldSelectorEditorView',
  LinkArrayEditor = 'LinkArrayEditor',
  CharArrayEditor = 'CharArrayEditor',
  ColorEditor = 'ColorEditor',
  ApprovalLevelsEditor = 'ApprovalLevelsEditor',
  PasswordEditor = 'PasswordTextModeEditor',
  TokenPicker = 'TokenPicker',
  StringFormat = 'StringFormatEditor',
  RadioList = 'default:radiolist',
  Shortcut = 'default:shortcut',
  SelectTagsEditor = 'SelectTagsEditor',
  FolderPickerEditor = 'FolderPickerEditor',
  GroupsPicker = 'GroupsPickerEditor',
  AccountsPicker = 'AccountsPickerEditor',
  TableTemplateEditor = 'TableTemplateEditor',
  TimeSpan = 'default:timespan',
  UpdateRuleDataTriggerEditor = 'UpdateRuleDataTriggerEditor',
  ImageInfo = 'Silverdark.Editors.ImagePicker.ImageInfoEditor,Silverdark.Editors, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
  DataDescriptionPathEditor = 'DataDescriptionPathEditor',
  ActiveDirectoryPickerEditor = 'ActiveDirectoryPickerEditor',
  ChartSourcePickerEditor = 'ChartSourcePickerEditor',
  ChartPartPicker = 'ChartPartPicker',
  TimePickerEditor = 'TimePickerEditor',
  FormDataPickerEditor = 'FormDataPickerEditor',
  EmbeddedPropertyGrid = 'PropertyGridEmbeddedEditor',
  DefinedTypeEditor = 'DefinedTypeEditor',
  GroupedListEditor = 'GroupedListEditor',
  TagFilterEditor = 'TagFilterEditor',
  ChartSeriesEditor = 'ChartSeriesEditor',
  DatePicker = 'DateEditor',
  DateAndTimePicker = 'DateAndTimeEditor',
  TimePicker = 'TimePickerEditor',
  FileContentPicker = 'FileContentPickerEditor',
  FormTriggerData = 'FormTriggerData',
  Thickness = 'ThicknessEditor',
  DateTimeArray = 'DateTimeArrayEditor',
  ChartTypePicker = 'ChartTypePickerEditor',
  ChartEntryFilter = 'ChartEntryFilterEditor',
  NumericRangeFilter = 'NumericRangeFilterEditor',
  StringMatchFilter = 'StringMatchFilterEditor',
  PickStringFilter = 'PickStringFilterEditor',
  CountDataFilter = 'CountDataFilterEditor',
  ReportDateRange = 'ReportDateRange',
  FilterDateRange = 'FilterDateRange',
  BoolDataFilter = 'BoolDataFilterEditor',
  StringWithPrefix = 'StringEditorWithPrefix',
  DataDesignerEditor = 'DataDesignerEditor',
  OutcomeScenariosEditor = 'OutcomeScenariosEditor',
  FilePickerEditor = 'FilePickerEditor',
  MultiFilePickerEditor = 'MultiFilePickerEditor',
  LayoutEntityEditor = 'LayoutEntityEditor',
  TypePickerEditor = 'TypePickerEditor',
  ReportFieldSelectorEditor = 'ReportFieldSelectorEditor',
  NumericFieldFilterEditor = 'NumericFieldFilterEditor',
  NumericFieldsFilterEditor = 'NumericFieldsFilterEditor',
  SelectByIcon = 'SelectByIconEditor',
  RangeSliderEditor = 'RangeSliderEditor',
}
